/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolHomeIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-home"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M3.4 19L3.4 10.05Q3.4 9.43 3.69 8.86Q3.98 8.3 4.47 7.92L10.43 3.48Q11.15 2.95 12 2.95Q12.85 2.95 13.57 3.48L19.52 7.92Q20.02 8.3 20.31 8.86Q20.6 9.43 20.6 10.05L20.6 19Q20.6 20.13 19.84 20.89Q19.07 21.65 17.95 21.65L15.57 21.65Q15.03 21.65 14.64 21.26Q14.25 20.88 14.25 20.32L14.25 15.32Q14.25 14.78 13.86 14.39Q13.47 14 12.93 14L11.07 14Q10.53 14 10.14 14.39Q9.75 14.78 9.75 15.32L9.75 20.32Q9.75 20.88 9.36 21.26Q8.97 21.65 8.43 21.65L6.05 21.65Q4.92 21.65 4.16 20.89Q3.4 20.13 3.4 19Z" fill={color} />
    </svg>
  );
}
